<template>
    <div class="brand">
        
            <div class="home-news">
                <img class="service-img" src="../../assets/black-logo.png">
                <div class="home-title">联系我们</div>
                <div class="home-paper">我们为您提供全方位的洗衣服务及护理方案</div>
            </div>

            <div class="brand-swiper">
                <div class="brand-swiper-nav">
                    <div class="partnerSwiper" v-if="servicePageImg.length">
                    <swiper :options="swiperOption" ref="mySwiper">
                      
                        <swiper-slide v-for="(item,index) in servicePageImg" :key="index">
                          <div class="brand-swiper-list">
                            <img class="bramd-swiper-img" :src="'https://branew-pic.oss-cn-beijing.aliyuncs.com/' + item.imageA">
                            <div class="brand-swiper-list-nav">
                              <div class="swiper-title">{{item.title}}</div>
                              <div class="swiper-introduction">{{item.content}}</div>
                            </div>
                          </div>
                        </swiper-slide>

                        <div class="swiper-pagination"  slot="pagination"></div>
                    </swiper>
                    </div>
                </div>
            </div>

        <div class="brand-nav">
            <div class="home-news">
                <div class="home-title">水洗洗护工艺</div>
                <div class="home-paper">9道工序，80种工艺</div>
                <div>标准程序共11个程序，适用于浅色棉类机织物；</div>
                <div>缓和程序共15个程序，适用于大部分衣物类型的洗涤，对具有功能性涂层的衣物、色牢度较低的衣物都有很好的保护；</div>
                <div>柔和程序共3个程序，适用于贴身衣物。</div>
                <div>使用离子交换树脂软水机处理的软水，洗涤用水达到饮用水标准；</div>
                <div>定期检测水洗机排水指标，确保衣物洁净度和洗衣液残留符合质量标准；</div>
                <div>采用德国西施（SEITZ）洗衣液。</div>
                <div class="service-nav-img">
                    <img src="../../assets/serviceProject/service-icon1.jpg" alt="">
                    <img src="../../assets/serviceProject/service-icon2.png" alt="">
                </div>
            </div>
            <div class="home-news">
                <div class="home-title">干洗洗护工艺</div>
                <div class="home-paper">8道工序，64种工艺</div>
                <div>采用意大利原装进口的瑞星和尤尼设备，使用美国陶氏原装进口PCE，干洗级PCE；</div>
                <div>依据PCE在不断洗涤和蒸馏的过程中酸化变质的特性，定期检测PCE纯净度和pH值，保证洗涤用PCE的品质，实现最佳洗后效果。</div>
                <div class="service-nav-img">
                    <img src="../../assets/serviceProject/service-icon3.png" alt="">
                    <img src="../../assets/serviceProject/service-icon4.jpg" alt="">
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import bus from '@/components/bus';

export default {
  name: 'Home',
  data(){
    return {
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 1,
        centeredSlides: true,
        loop: true,
        // 如果需要分页器
        pagination: {
          el:'.swiper-pagination',
          clickable: true,
        },
        // notNextTick: true,
        // 如果需要自动播放
        // autoplay : {
        //   delay:3000,
        //   disableOnInteraction:false,  //用户操作swiper之后，是否禁止autoplay。
        // },
        // 如果需要前进后退按钮
        // navigation: {
        //   nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
        //   prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
        //   hideOnClick: true, //点击slide时显示/隐藏按钮
        // },
      },
      servicePageImg: [],
    }
  },
  created(){
    this.$exec('page.img',1).then(result => {
      this.servicePageImg = result.data.data;
    })
  },
  mounted(){
      bus.$emit('changeRoute', this.$route.path);
  },
  
}
</script>
<style scoped lang="scss">
.home{
    width: 100%;
    background: #F3F5FA;
    overflow: hidden;
}
.home-img{
  width: 100%;
  height: 47rem;
}
.brand-nav{
  padding: 0 12rem;
}
.service-img{
  width: 1.5rem;
  height: 1.7rem;
  margin-top: 3rem;
}
.home-title{
  font-size: 2rem;
  margin: 1rem 0;
}
.home-paper{
  font-size: 1rem;
  margin-bottom: 1rem;
}
.service-nav-img{
    display: flex;
    justify-content: space-between;
    margin: 3rem 0 5rem;

    img{
        width: 47.5%;
        height: 34.5rem;
    }
}
.brand-swiper{
  // padding: 0 12rem;

  .brand-swiper-nav{
    position: relative;
  }

  .partnerSwiper{
    overflow: hidden;
    margin: 3rem 0;

    .swiper-slide{
      // border: 1px solid #aaa;
      // padding: 1rem;
      background: #fff;
      border-radius: 10px 10px 0 0;
    }
  }
}
.swiper-container {
    width: 100%;
    height: 100%;
}
.swiper-pagination{
    left: 0;
    right: 0;
}
.swiper-slide {
    text-align: center;
    font-size: 18px;
    // background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
    transform: scale(0.8);
}
.swiper-slide-active,.swiper-slide-duplicate-active{
    transform: scale(1);
}
::v-deep .swiper-pagination-bullet{
    width: 0.3rem;
    margin: 0 0.2rem;
    height: 0.3rem;
}
::v-deep .swiper-pagination-bullet-active{
    background: #00146E;
    width: 0.4rem;
    height: 0.4rem;
}

.brand-swiper-list{
  width: 100%;

  img{
    width: 100%;
    border-radius: 10px 10px 0 0;
  }

  .brand-swiper-list-nav{
    width: 100%;
    background: #fff;
    padding: 2rem;

    .swiper-title{
      font-size: 1.5rem;
      margin-bottom: 1rem;
    }
    .swiper-introduction{
      font-size: 1rem;
    }
  }
}
</style>